import { render, staticRenderFns } from "./primary-organization-selector.vue?vue&type=template&id=42ed0fa5"
import script from "./primary-organization-selector.vue?vue&type=script&lang=js"
export * from "./primary-organization-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports